import { useContext } from 'react'

import UserContext from '../../context/User/User'

import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { checkPermission } from '../../utilities/helpers'
import AuthService from '../../utilities/services/auth.service'

import { PageLoadingContainer } from '../PageLoadingContainer'
import { NoPermissionsContainer } from '../NoPermissionsContainer'
import UsersSearch from './UsersSearch'

export default function UsersWrapper() {
  const { orgPermissions } = useContext(UserContext)
  const orgPermissionsReady = orgPermissions?.length > 0
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      AuthService.getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_ORDERS
    )

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  if (!hasPermission) {
    return (
      <div className="spacer-sm">
        <NoPermissionsContainer />
      </div>
    )
  }

  const organization = AuthService.getOrg()?.[0]

  return (
    <section className="spacer-sm" data-testid="users-wrapper-content">
      <header className="section-header-sm">
        <div className="section-heading">
          <h1>Users</h1>
        </div>
        <p className="section-header-desc">
          Search buyers for this organization and open their profile.
        </p>
      </header>
      <UsersSearch organization={organization} />
    </section>
  )
}
